import { navigateToUrl } from 'single-spa';

export const removeMainLoading = () => {
  const elt = document.getElementById('main_loading');
  if (!elt) return;
  elt.remove();
};

// Redirect to path
export const autoRedirectTo = () => {
  const query = new URLSearchParams(window.location.search);
  const redirectTo = decodeURIComponent(query.get('redirect_to') || '').replace(
    /^\/+/,
    '',
  );

  if (redirectTo) navigateToUrl(redirectTo);
};

const parseThemeSetting = (setting: string) => {
  try {
    return JSON.parse(setting) as { colorPalette: object };
  } catch (error) {
    console.error('Theme Setting Error', error);
    return;
  }
};

// export const customTheme = (context: ContextParams) => {
//   if (!context.bootstrap.get()?.themeSetting) return;
//   const themeSetting = parseThemeSetting(context.bootstrap.get()?.themeSetting);
//   if (!themeSetting) return;
//   Object.entries(themeSetting.colorPalette).forEach(([k, v]) => {
//     document.body.style.setProperty(k, v);
//   });

//   // const themeSetting = {
//   //   '--primary-color': '#177837',
//   //   '--light-primary-color': '#177837',
//   //   '--light-hover-primary-color': '#209547',
//   //   '--button-bg-color': '#177837',
//   //   '--border-radius': '4px',

//   //   '--primary-bg-color': '#0A4F21',

//   //   '--content-bg-color': '#fff',
//   //   '--content-button-bg-color': '#ECFEF2',
//   //   '--content-button-text-color': '#177837',
//   //   '--content-slide-button-bg-color': '#f2f2f2',
//   //   '--content-slide-button-active-color': '#454A58',
//   //   '--content-slide-button-inactive-color': '#fff',

//   //   '--primary-text-color-deposit': '#177837',
//   //   '--banner-button-bg-color': '#ADEA5E',

//   //   '--primary-text-color': '#fff',
//   //   '--inactive-header-text-color': 'rgba(255, 255, 255, 0.7)',
//   //   '--text-color': '#333',
//   //   '--primary-content-text-color': '#000',
//   //   '--light-primary-text-color': '#D0F7DD',

//   //   '--light-hover-sport-color': 'rgb(20 111 50 / 84%)',
//   //   '--header-bg-color': '#146F32',
//   //   '--header-button-bg-color-20': 'rgba(255, 255, 255, 0.2)',
//   //   '--header-button-bg-color': '#ADEA5E',
//   //   '--header-button-bg-hover-color': '#9adb45',

//   //   '--right-core-border-primary': '#053C17',
//   //   '--right-chosen-button-bg-color': '#146F32',

//   //   '--left-hover-primary-color': '#ECFEF2',

//   //   '--core-border-primary-10': '#dbe5ff',
//   //   '--core-background-primary-40': '#177837',

//   //   '--core-background-neutral-0': '#fff',
//   //   '--core-background-neutral-5': '#F7F9FC',
//   //   '--core-background-neutral-10': '#f2f4f7',

//   //   '--core-content-primary-40': '#146F32',
//   //   '--core-content-primary-60': '#053C17',

//   //   '--button-neutral-primary-default-container-color': '#ECFEF2',
//   //   '--button-neutral-primary-hover-label-text-color': '#156f32',
//   //   '--button-neutral-primary-hover-container-color': '#209547',
//   //   '--button-secondary-default-container-color': '#156f32',
//   //   '--button-secondary-hover-container-color': '#209547',
//   // };
//   // Object.entries(themeSetting).forEach(([k, v]) => {
//   //   document.body.style.setProperty(k, v);
//   // });
// };
